<script lang="ts" setup></script>

<template>
  <div class="my-1 h-[1px] w-full bg-gray-100"></div>
</template>
